import React from 'react'
import { Link } from 'react-router-dom'

const Header = ({data}) => {
    console.log('--->data',data);
    return (
        <div className="container-fluid hero-header bg-light py-5 mb-5 mt-5">
            <div className="container py-5">
                <div className="row g-5 align-items-center">
                    <div className="col-lg-6">
                        <p className="text-primary text-uppercase mb-2 animated slideInDown">
                            Welcome To ProArt Digital Studio
                        </p>
                        <h1 className="display-4 mb-3 animated slideInDown">
                            The photography specialists.
                        </h1>
                        <p className="animated slideInDown">
                        The photography specialists for all your special moments, from pre-wedding to wedding and beyond, capturing every detail with expertise
                        </p>
                        <div className="d-flex align-items-center pt-4 animated slideInDown">
                            <Link href="" className="btn btn-primary py-3 px-4 me-5">
                                Explore More
                            </Link>
                            <button
                                type="button"
                                className="btn-play cursor-pointer"
                                onClick={() => window.open("https://www.youtube.com/shorts/DwKHhON_DZw", "_blank")}
                            >
                                <span />
                            </button>
                            <h5 className="ms-4 mb-0 d-none d-sm-block">Play Video</h5>
                        </div>
                    </div>
                    <div className="col-lg-6 animated fadeIn">
                        <div className="row g-3">
                            <div className="col-6 text-end">
                                <img
                                    className="img-fluid bg-white p-3 w-100 mb-3"
                                    src={data[2]}
                                    alt=""
                                />
                                <img
                                    className="img-fluid bg-white p-3 w-50"
                                    src={data[0]}
                                    alt=""
                                />
                            </div>
                            <div className="col-6">
                                <img
                                    className="img-fluid bg-white p-3 w-50 mb-3"
                                    src={data[1]}
                                    alt=""
                                />
                                <img
                                    className="img-fluid bg-white p-3 w-100"
                                    src={data[3]}
                                    alt=""
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default Header
